export default __webpack_public_path__ + "static/media/onboarding_bg.feec65bf.png";